import { createContext } from 'react';

export type CardEditPopoverShellMode = 'legacy' | 'dialog';

export type CardEditPopoverShellContextValue = {
  mode: CardEditPopoverShellMode;
};

export const CardEditPopoverShellContext = createContext<CardEditPopoverShellContextValue>({
  mode: 'legacy',
});
